module.exports = __webpack_public_path__ + "img/canada-stomach-cancer-female.01ff0307.png";